<template>
    <div class="main">
      <div id="header">
          <h1>{{ $t('lang.ranking') }}</h1>
          <div class="rules">
            <p>{{ $t('lang.ruleParagraph') }}</p>
            <p>{{ $t('lang.ruleParagraph2') }}</p>
          </div>
          <!--<button class="share">
              <i class="ph ph-share-network"></i>
          </button>-->
      </div>
      <div class="leaderboard" id="leaderboard">
<!--          <div class="ribbon"></div>-->
          <table>
              <tr v-for="(token, index) in tokens" :key="index" class="table-row">
                  <td class="name">
                      <div style="display: flex; align-items: center; gap: 1rem;">
                        {{ index + 1 }}  {{ token.symbol }}
                        <img :src="require(`@/assets/img/ranking/${token.symbol}-logo.png`)" style="height: 24px;"/>
<!--                        @click="handleClick(token.symbol)"-->
                      </div>
                  </td>
                  <td class="points">
<!--                      <img v-if="index == 0" class="gold-medal" src="https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true" alt="gold medal"/>-->
<!--                    <div class="progress-bar">-->
<!--                      <div class="progress" :style="{ width: token.percent + '%' }" > per: {{token.percent}} </div>-->
<!--                    </div>-->
                    <p>{{ token.totalVotes }}</p>
                  </td>
              </tr>
          </table>
      </div>
<!--      <div style="display: flex; flex-direction: column; align-items: center; gap: 2rem;">-->
<!--        <div><h3 style="font-size: 2rem;">{{ $t('lang.youVotedFor') }}</h3></div>-->
<!--        <div class="voteHist" style="display: flex; gap: 1rem">-->
<!--          <div v-for="(vote, index) in votes" :key="index" style="display: flex; align-items: center; gap: 0.5rem;">-->
<!--            <img :src="require(`@/assets/img/ranking/${vote.symbol}-logo.png`)"style="height: 28px;"/>-->
<!--            {{ `X ${vote.count}` }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
</template>

<script>
    export default {
        props: {
            tokens: Array,
            votes: Array
        },
        created() {
          this.lang = sessionStorage.getItem("Language");
        },
      methods: {

        }
    }

</script>

<style lang="less" scoped>
//    * {
//  font-size: 62, 5%;
//  box-sizing: border-box;
//  margin: 0;
//}

.main{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  //-webkit-box-shadow: 0px 5px 15px 8px #000;
  //box-shadow: 0px 5px 15px 8px #000;
  flex-direction: column;
  border-radius: 30px;
}

#header {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: space-between;
}


.share:active {
  border-bottom: 0;
}

.share i {
  color: #fff;
  font-size: 2rem;
}

h1 {
  padding-top: 2%;
  font-family: "Rubik", sans-serif;
  font-size: 26px;
  background: linear-gradient(90deg, rgba(242, 106, 255, 1), rgba(125, 111, 255, 1));
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  text-transform: uppercase;
  cursor: default;
}

#leaderboard {
  width: 100%;

  position: relative;
}

table {
  width: 100%;
  border-collapse: separate; /* Change to separate */
  border-spacing: 0; /* Adjust spacing if needed */
  table-layout: fixed;
  cursor: default;
}

tr {
  transition: all 0.2s ease-in-out;
}


tr:hover { //not(:first-child)
  transform: scale(1.05);
  //-webkit-box-shadow: 0px 2px 6px 2px #e4e7fb;
  //box-shadow: 0px 2px 6px 2px #e4e7fb;
}

tr:nth-child(odd) {
  //background-color: #f9f9f9;
}

tr:nth-child(1) {
  //color: #fff;
}

td {
  font-family: "Rubik", sans-serif;
  padding: 1rem 2rem;
  position: relative;
}

.name {
  margin-left: 2rem;
  height: 60px;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  width: 170px;
}

.points {
  height: 60px;
  font-weight: bold;
  font-size: 24px;
  margin-right: 2rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .progress-bar {
    position: absolute;
    left: 0;
    width: 90%;
    background-color: #e0e0e0;
    border-radius: 25px;
    overflow: hidden;
  }

  .progress {
    width: 50%; /* Adjust this value to represent the progress */
    height: 30px;
    background: linear-gradient(90deg, rgba(242, 106, 255, 0.5), rgba(125, 111, 255, 0.5));
    text-align: center;
    line-height: 30px; /* Same as the height to center the text */
    color: white;
    border-radius: 25px 0 0 25px;
  }
  p{
    position: absolute;
    right: 0px;
    z-index: 100;
  }
}


.gold-medal {
  height: 3rem;
  margin-left: 1.5rem;
}

.ribbon {
  width: calc(100% + 2rem);
  max-width: 100vw;
  height: 4rem;
  top: -0.5rem;
  left: -1rem;
  background-color: #5c5be5;
  position: absolute;
  -webkit-box-shadow: 0px 15px 11px -6px #7a7a7d;
  box-shadow: 0px 15px 11px -6px #7a7a7d;
}

#buttons {
  width: 100%;
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.exit {
  width: 11rem;
  height: 3rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.3rem;
  text-transform: uppercase;
  color: #7e7f86;
  border: 0;
  background-color: #fff;
  border-radius: 2rem;
  cursor: pointer;
}

.exit:hover {
  border: 0.1rem solid #5c5be5;
}

.continue {
  width: 11rem;
  height: 3rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.3rem;
  color: #fff;
  text-transform: uppercase;
  background-color: #5c5be5;
  border: 0;
  border-bottom: 0.2rem solid #3838b8;
  border-radius: 2rem;
  cursor: pointer;
}

.continue:active {
  border-bottom: 0;
}

@media (max-width: 390px) {
    .voteHist {
      flex-direction: column;
      gap: 0
    }
}
</style>